import { useNavigate } from 'react-router-dom';

import { AppRouteWithParams } from 'routing/AppRoute.enum';
import { AddEventExportFormatPageModeEnum } from '../../addEventExportFormat/AddEventExportFormat.enum';

import { DeleteEventExportFormatContainer } from './deleteEventExportFormat/DeleteEventExportFormatContainer';
import { EventExportFormatsActionsProps } from './EventsExportFormatsActions.types';
import * as Styled from './EventsExportFormatsActions.styles';

export const EventsExportFormatsActions = ({ row }: EventExportFormatsActionsProps) => {
  const navigate = useNavigate();

  if (row.kind === 'SYSTEMOWE') {
    return (
      <Styled.ClosedEyeIcon
        onClick={() =>
          navigate(
            AppRouteWithParams.eventsExportFormats.get({
              id: row.formatTyp,
              mode: AddEventExportFormatPageModeEnum.PREVIEW,
            }),
          )
        }
      />
    );
  }

  return (
    <>
      <Styled.PenIcon
        onClick={() =>
          navigate(
            AppRouteWithParams.eventsExportFormats.get({
              id: row.id,
              mode: AddEventExportFormatPageModeEnum.EDIT,
            }),
          )
        }
      />

      <DeleteEventExportFormatContainer eventExportFormat={row.data} />
    </>
  );
};
